// material-ui

// project import
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { LoadingButton } from '@mui/lab';
import { Alert, Button, Card, CardActions, CardContent, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography } from '@mui/material';
import { Box } from '@mui/system';
import CircleLoader from 'components/CircleLoader';
import MainCard from 'components/MainCard';
import { Notice } from 'components/Notice';
import config from 'config';
import { isShopifyApp, UserAuthContext } from 'context/UserAuthContext';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { getRequest, postRequest } from 'utils/apiRequest';
import { getUrlForPath, trackConversion } from 'utils/functions';
import PaymentForm from './PaymentForm';

// ==============================|| SAMPLE PAGE ||============================== //


const isCurrentPlan = (plan, getSubscriptionName) => {
    return getSubscriptionName().toLowerCase() === plan.name.toLowerCase();
}

const Feature = ({ value }) => {
    if (value == "Yes" || value == 'No') {
        return value === 'Yes' ? <CheckOutlinedIcon style={{ fontWeight: 'bold', color: "green" }} /> : <CloseOutlinedIcon style={{ fontWeight: 'bold', color: "red" }} />
    }
    return <>{value}</>;
}

const PlanCard = ({ provider, plan }) => {
    const { isShopifyApp, getUserFromStorage, getSubscriptionName, hasSubscription } = React.useContext(UserAuthContext);
    const isCurrent = isCurrentPlan(plan, getSubscriptionName);
    const [submitting, setSubmitting] = React.useState(false);
    const [stripePaymentFormDetails, setStripePaymentFormDetails] = React.useState({open: false, clientSecret: null, callbackUrl: null});
    
    const isEnterprisePlan = plan.name === 'Enterprise';
    const navigate = useNavigate();

    const handleOnClick = () => {
        setSubmitting(true);
        purchasePlan(getUserFromStorage(), provider, plan)
    }

    const purchasePlan = (user, provider, plan) => {
        // let url = plan.urls.stripe;
        // if(provider === 'shopify'){
        //     const redirectUri = plan.urls.shopify + '&shop='+localStorage.getItem('shopify_shop');
        //     url =  getUrlForPath('ExitIframe?redirectUri='+encodeURIComponent(redirectUri));
        // }else{
        //     url = plan.urls.stripe + '?prefilled_email='+encodeURIComponent(user.email);
        // }
        // console.log(url, user)
        // window.location.href = url;

            postRequest('/subscription/change', {
                provider: provider,
                plan: plan.name,
                shop: localStorage.getItem('shopify_shop')
            }).then(data => {
                if(data && data.redirectUrl){

                    trackConversion('purchase_'+plan.name.toLowerCase());
                    setTimeout(()=>{
                        if(data.redirectUrl.indexOf('ExitIframe') > -1){
                            navigate(data.redirectUrl.substring(data.redirectUrl.indexOf('/ExitIframe')));
                        }else{
                            window.location.href = data.redirectUrl;
                        }
                    }, 500);
                }else if(data && data.stripe){
                    // new subscriber, who dis?
                    setStripePaymentFormDetails({open: true, clientSecret: data.stripe.client_secret, callbackUrl: data.stripe.callbackUrl});
                }
            }).finally(()=>{
                setSubmitting(false)
            })
    }

    const Price = () => {
        return (isEnterprisePlan ? (<>Contact Us</>) : (<>
        {new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(plan.price.month)}
        <small>/month</small>
        </>));
    }

    const CallToAction = () => {
        return (<>
        {isCurrent ? (
                <Button disabled={isCurrent} fullWidth variant="contained" color="primary">Current Plan</Button>
            ) : (
                isEnterprisePlan ?  (<>
                    <Button fullWidth variant="contained" color="primary" target="_blank" href="https://www.convertlogistics.com/contact-us?plan=enterprise">Contact Us</Button>
                </>) : (<>
                    <LoadingButton fullWidth variant="contained" color="primary" loading={submitting} onClick={()=>handleOnClick()}>Choose Plan</LoadingButton>
                </>)
            )}
        </>)
    }

    return (<>
    <Card>
        <CardHeader title={plan.name} subheader={isCurrent ? 'Current Plan' : ''}  sx={{pb: isCurrent ? 0 : 2.7}} />
        <CardContent sx={{pt:0}}>
            <Typography variant="body1"><small>14-day Free Trial</small></Typography>
            <Typography variant="h5"><Price /></Typography>
            <hr />
            <Typography variant="subtitle1" sx={{mb: 1}}>Plan Highlights:</Typography>
            {plan.features.map((feat, n) => {
                if(n < 4){
                return <Typography key={n} variant="overline" sx={{mb: 1, display: 'block'}}>
                    <Typography fontWeight={'bold'} display="inline-block">{feat.name}:</Typography> {feat.value}
                </Typography>
                }
            })}
        </CardContent>
        <CardActions>
            <CallToAction />
        </CardActions>
    </Card>
    {stripePaymentFormDetails.open && (
        <>
            <Dialog
                open={stripePaymentFormDetails.open}>
                    <DialogTitle>Payment Details</DialogTitle>
                    <DialogContent sx={{minWidth: 500}}>
                        <PaymentForm {...stripePaymentFormDetails} onClose={() => setStripePaymentFormDetails({...stripePaymentFormDetails, open: false})} />
                    </DialogContent>
                </Dialog>
        </>
    )}
    </>
    )
}

const SubscriptionPlansViaStripe = ({plans}) => {
    // return (<MainCard title="Subscription Plans" sx={{ mb: 2 }}>
    //     <stripe-pricing-table pricing-table-id={process.env.REACT_APP_STRIPE_PRICING_TABLE_ID}
    //         publishable-key={process.env.REACT_APP_STRIPE_PRICING_TABLE_KEY}>
    //     </stripe-pricing-table>
    // </MainCard>
    // );
    return <SubscriptionPlansViaShopify plans={plans} provider="stripe" />
}
const SubscriptionPlansViaShopify = ({plans, provider}) => {
    const { hasSubscription} = React.useContext(UserAuthContext);
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const handleCancelSubscription = () => {
        setSuccessMessage(null);
        setErrorMessage(null);
        postRequest('/subscription/cancel', {
            provider: provider
        }).then(d => {
            if(d.cancelled){
                setSuccessMessage(d.message);
            }else{
                setErrorMessage(d.message);
            }
        }).catch((err)=>{
            console.error(err)
        })
    }
    return (<>
        {/* <MainCard title="Subscription Plans" sx={{ mb: 2 }}> */}
        <Typography variant="h3" mb={3}>Subscription Plans</Typography>
            {successMessage !== null && <Alert sx={{mb: 2}} variant="filled" color="success">{successMessage}</Alert>}
            {errorMessage !== null && <Alert sx={{mb: 2}} variant="filled" icon={<></>} color="error">{errorMessage}</Alert>}
            <Grid container spacing={3} sx={{mb: 3}}>
                {plans.map((plan, i) => {
                    return <Grid item key={i} xs={6} sm={6} md={3} lg={3} xl={3}>
                        <PlanCard plan={plan} provider={provider} />
                    </Grid>
                })}
            </Grid>
            {hasSubscription() && <Typography variant="caption">To cancel your subscription completely, <Link onClick={()=>handleCancelSubscription()} href="#">click here</Link></Typography>}
        {/* </MainCard> */}
    </>);
}

const SubscriptionPlanOptions = ({ plans }) => {
    const { getSubscriptionSource } = React.useContext(UserAuthContext);
    if(isShopifyApp() || getSubscriptionSource() === 'shopify'){
        return <SubscriptionPlansViaShopify plans={plans} provider="shopify" />
    }else{
        return <SubscriptionPlansViaStripe plans={plans} provider="stripe" />
    }
}


const SubscriptionsPage = () => {
    const { getUser, hasSubscription, getSubscriptionSource, getSubscriptionName } = React.useContext(UserAuthContext);
    const [plans, setPlans] = React.useState([])
    const subscriptionSourceIsStripe = getSubscriptionSource() === 'stripe';
    const [loading, setLoading] = React.useState(true);
    const [trailEndsAt, setTrialEndsAt] = React.useState(null);

    useEffect(() => {
        if (subscriptionSourceIsStripe) {
            if (document.getElementById('stripe-pricing-table')) {
                return;
            }
            const src = 'https://js.stripe.com/v3/pricing-table.js';
            const script = document.createElement('script');
            script.src = src;
            script.id = 'stripe-pricing-table';
            script.async = true;
            document.getElementsByTagName('head')[0].appendChild(script);

        }
        getUser().then((u)=>{
            setTrialEndsAt(u.trial_ends_at);
            getRequest('/plans').then((data) => {
                setPlans(data);
            }).finally(() => {
                setLoading(false);
            })
        });
    }, []);
    return (<>
        {loading ? <CircleLoader /> : (<>
        {!hasSubscription() && (
            <Alert severity="error" sx={{ mb: 2 }}>Your account does not have an active subscription. You will need to select one below before you can access other parts of the site. All plans come with a 14-day free trial.</Alert>
        )}
        <SubscriptionPlanOptions plans={plans} />
        <MainCard title="Subscription Features">
            {plans.length > 0 && (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell width={350}></TableCell>
                            {plans.map((plan, i) => {
                                const isCurrent = isCurrentPlan(plan, getSubscriptionName)
                                return <TableCell key={i} align="center" sx={{ backgroundColor: isCurrent ? 'lightyellow' : null }}>{plan.name}</TableCell>
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {plans[0].features.map((feat, n) => {
                            return (<TableRow key={n}>
                                <TableCell align="left" style={{ fontWeight: 'bold' }}>{feat.name}</TableCell>
                                {plans.map((plan, i) => {
                                    const isCurrent = isCurrentPlan(plan, getSubscriptionName);
                                    return plan.features.map((feat2, n) => {
                                        return (feat.name === feat2.name && (
                                            <TableCell align="center" key={i + '-' + n} sx={{ backgroundColor: isCurrent ? 'lightyellow' : null }}>
                                                <Feature value={feat2.value} />
                                            </TableCell>)
                                        );
                                    })
                                })}
                            </TableRow>)
                        }
                        )}

                    </TableBody>
                    {/* <TableFooter>
                        <TableRow>
                            <TableCell width={350}></TableCell>
                            {plans.map((plan, i) => {
                                const isCurrent = isCurrentPlan(plan, getSubscriptionName)
                                return <TableCell key={i} align="center" sx={{ backgroundColor: isCurrent ? 'lightyellow' : null }}>
                                    <Button variant="contained" color="primary">Buy Now</Button>    
                                </TableCell>
                            })}
                        </TableRow>
                    </TableFooter> */}
                </Table>)}
        </MainCard>
        </>)}
    </>)
};

export default SubscriptionsPage;
